<template>
    <b-navbar toggleable="md" type="light" variant="light" class="px-3">
      <!-- Logo DERCO a la izquierda -->
      <b-navbar-brand :to="{ name: 'BrandListClient' }">
        <img src="../../assets/Derco.gif" width="48" alt="">
      </b-navbar-brand>

      <!-- Mobile: seccion activa + hamburguesa -->
      <div class="d-md-none ml-auto d-flex align-items-center">
        <span class="mobile-section-label mr-2">{{ currentMenuLabel }}</span>
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      </div>

      <b-collapse is-nav id="nav_collapse">
        <!-- MOBILE: lista plana sin dropdown (un solo clic burger -> items visibles) -->
        <b-navbar-nav class="ml-auto d-md-none mobile-nav-list">
          <b-nav-item :to="{ name: 'BrandListClient' }">Clientes x marca</b-nav-item>
          <b-nav-item :to="{ name: 'BrandListOffices' }">Oficinas por marca</b-nav-item>
          <b-nav-item :to="{ name: 'BrandListModels' }">Modelos por marca</b-nav-item>
          <b-nav-item :to="{ name: 'BrandList' }">Marcas</b-nav-item>
          <b-nav-item :to="{ name: 'Contacts' }">Contacto</b-nav-item>
          <b-nav-item :to="{ name: 'TestDrives' }">Test Drive</b-nav-item>
          <b-nav-item :to="{ name: 'Auditoria' }">Auditoría</b-nav-item>
          <b-nav-item :to="{ name: 'Register' }">Registrar</b-nav-item>
          <b-nav-item :to="{ name: 'UsersList' }">Usuarios</b-nav-item>
          <b-nav-item @click.prevent="logout()" class="mobile-logout">Cerrar Sesión</b-nav-item>
        </b-navbar-nav>

        <!-- DESKTOP: dropdown con pill -->
        <b-navbar-nav class="ml-auto d-none d-md-block">
          <b-nav-item-dropdown
            :text="currentMenuLabel"
            right
            toggle-class="nav-drop-custom"
            menu-class="menu-dropdown"
          >
            <b-dropdown-item :to="{ name: 'BrandListClient' }">Clientes x marca</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'BrandListOffices' }">Oficinas por marca</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'BrandListModels' }">Modelos por marca</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'BrandList' }">Marcas</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item :to="{ name: 'Contacts' }">Contacto</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'TestDrives' }">Test Drive</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item :to="{ name: 'Auditoria' }">Auditoría</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item :to="{ name: 'Register' }">Registrar</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'UsersList' }">Usuarios</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <li role="presentation" class="logout-li">
              <a class="dropdown-item dropdown-item-logout" href="#" @click.prevent="logout()">
                Cerrar Sesión
              </a>
            </li>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
</template>

<script>
/*eslint-disable */
export default {
  name: 'Header',
  computed: {
    currentMenuLabel () {
      const map = {
        'BrandListClient': 'Clientes x marca',
        'BrandListOffices': 'Oficinas por marca',
        'BrandListModels': 'Modelos por marca',
        'BrandList': 'Marcas',
        'Contacts': 'Contacto',
        'TestDrives': 'Test Drive',
        'Auditoria': 'Auditoría',
        'Register': 'Registrar',
        'UsersList': 'Usuarios',
        'ClientListByBrands': 'Clientes x marca',
        'ShowClientByBrand': 'Clientes x marca',
        'EditClient': 'Clientes x marca',
        'CreateClient': 'Clientes x marca',
        'ClientList': 'Clientes x marca',
        'ShowClient': 'Clientes x marca',
        'OfficeListByBrand': 'Oficinas por marca',
        'ShowOffice': 'Oficinas por marca',
        'EditOffice': 'Oficinas por marca',
        'CreateOffice': 'Oficinas por marca',
        'ModelsListByBrand': 'Modelos por marca',
        'ShowModel': 'Modelos por marca',
        'CreateModel': 'Modelos por marca',
        'EditModel': 'Modelos por marca',
        'VersionesByModel': 'Modelos por marca',
        'CreateVersion': 'Modelos por marca',
        'ShowVersion': 'Modelos por marca',
        'EditVersion': 'Modelos por marca',
        'ShowBrand': 'Marcas',
        'EditBrand': 'Marcas',
        'CreateBrand': 'Marcas',
        'ContactListByBrands': 'Contacto',
        'ShowContactByBrand': 'Contacto',
        'EditContact': 'Contacto',
        'TestDrivesListByBrands': 'Test Drive',
        'ShowTestDriveByBrand': 'Test Drive',
        'EditTestDrive': 'Test Drive',
        'ShowUser': 'Usuarios',
        'EditUser': 'Usuarios',
        'SupervisorIndex': 'Clientes x marca',
        'SupervisorShowClient': 'Clientes x marca',
        'SupervisorEditClient': 'Clientes x marca',
        'SupervisorClientListByBrands': 'Clientes x marca',
        'SupervisorOffices': 'Oficinas por marca',
        'SupervisorShowOffice': 'Oficinas por marca',
        'SupervisorEditOffice': 'Oficinas por marca',
        'SupervisorShowOfficeDetails': 'Oficinas por marca',
        'SupervisorContacts': 'Contacto',
        'SupervisorShowContact': 'Contacto',
        'SupervisorEditContact': 'Contacto',
        'SupervisorTestDrives': 'Test Drive',
        'SupervisorShowTestDrive': 'Test Drive',
        'SupervisorEditTestDrive': 'Test Drive',
      };
      const name = this.$route ? this.$route.name : null;
      return map[name] || 'Clientes x marca';
    }
  },
  methods: {
    logout () {
      localStorage.removeItem('jwtToken')
      localStorage.removeItem('id')
      localStorage.removeItem('role')
      localStorage.removeItem('brand')
      this.$router.push({ name: 'Login' })
    }
  }
}
</script>

<style scoped>
.navbar {
  border-bottom: 2px solid #e41b17;
  margin-bottom: 0.5rem;
  min-height: 52px;
}
.navbar-brand {
  padding: 0;
  margin: 0;
}
.navbar-brand img {
  display: block;
}

/* Mobile: label de seccion activa */
.mobile-section-label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
}

/* Dropdown toggle: estilo pill rojo, texto e icono blancos */
.nav-drop-custom {
  font-weight: 600;
  background: #e41b17 !important;
  color: #fff !important;
  border-radius: 50px !important;
  padding: 0.4rem 1rem !important;
  border: none !important;
  transition: background 0.15s ease;
  box-shadow: none !important;
}
.nav-drop-custom::after {
  border-top-color: #fff !important;
  border-bottom-color: #fff !important;
}
.nav-drop-custom:hover,
.nav-drop-custom:focus,
.nav-drop-custom:active,
.nav-drop-custom[aria-expanded="true"] {
  background: #b91512 !important;
  color: #fff !important;
}

/* Dropdown menu centrado */
.menu-dropdown {
  text-align: center;
}
.menu-dropdown .dropdown-item {
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  transition: background 0.1s;
  outline: none !important;
  text-align: center;
}
.menu-dropdown .dropdown-item:hover {
  background: rgba(228, 27, 23, 0.08);
  color: #e41b17;
}
.menu-dropdown .dropdown-item:focus,
.menu-dropdown .dropdown-item:active,
.menu-dropdown .dropdown-item.active {
  background: #e41b17 !important;
  color: #fff !important;
  outline: none !important;
  box-shadow: none !important;
}

/* Cerrar Sesion: fondo rojo transparente, texto sin indent, sin borde */
.logout-li {
  list-style: none;
}
.logout-li .dropdown-item-logout {
  background: rgba(228, 27, 23, 0.08) !important;
  color: #e41b17 !important;
  font-weight: 600 !important;
  text-align: center !important;
  padding: 0.5rem 1rem !important;
  border-radius: 0 !important;
  border: none !important;
  text-decoration: none;
  display: block;
  width: 100%;
  cursor: pointer;
}
.logout-li .dropdown-item-logout:hover {
  background: rgba(228, 27, 23, 0.15) !important;
  color: #e41b17 !important;
}
.logout-li .dropdown-item-logout:focus,
.logout-li .dropdown-item-logout:active {
  outline: none !important;
  box-shadow: none !important;
  background: rgba(228, 27, 23, 0.15) !important;
  color: #e41b17 !important;
}

/* Mobile nav: lista plana dentro del collapse */
.mobile-nav-list .nav-link {
  text-align: center !important;
  padding: 0.6rem 1rem !important;
  border-bottom: 1px solid rgba(0,0,0,0.05);
  font-weight: 500;
}
.mobile-nav-list .nav-link.active,
.mobile-nav-list .nav-link.router-link-exact-active {
  background: #e41b17 !important;
  color: #fff !important;
  border-radius: 0 !important;
}
.mobile-logout {
  background: rgba(228, 27, 23, 0.08) !important;
  color: #e41b17 !important;
  font-weight: 600 !important;
  text-align: center !important;
}
.mobile-logout .nav-link {
  color: #e41b17 !important;
  font-weight: 600 !important;
  text-align: center !important;
}
.mobile-logout:hover {
  background: rgba(228, 27, 23, 0.15) !important;
}

/* Toggle hamburguesa */
.navbar-toggler {
  border-color: rgba(228, 27, 23, 0.3);
  padding: 0.25rem 0.5rem;
}
.navbar-toggler-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(228,27,23,0.8)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
}
</style>


// WEBPACK FOOTER //
// src/components/Supervisor/Header.vue